module.exports = __webpack_public_path__ + "img/20220112_103220.de6a0589.jpg";